var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _AsyncStateHandler_instances, _AsyncStateHandler_lastTrigger, _AsyncStateHandler_resolutionValue, _AsyncStateHandler_rejectionError, _AsyncStateHandler_listeners, _AsyncStateHandler_lastSetPromise, _AsyncStateHandler_waitingForValuePromise, _AsyncStateHandler_fireListeners, _AsyncStateHandler_setPromise, _AsyncStateHandler_resolveValue;
import { areJsonEqual, createDeferredPromiseWrapper, ensureError, filterObject, isPromiseLike, mapObjectValues, } from '@augment-vir/common';
const asyncMarkerSymbol = Symbol('element-vir-async-state-marker');
export function isRenderReady(asyncStateInput) {
    if (asyncStateInput instanceof Error) {
        return false;
    }
    else if (isPromiseLike(asyncStateInput)) {
        return false;
    }
    else {
        return true;
    }
}
export function toAsyncStateHandlerMap(propertyInitMap) {
    if (!propertyInitMap) {
        return {};
    }
    const asyncStateInit = filterObject(propertyInitMap, (key, value) => {
        return value instanceof AsyncStateInit;
    });
    const asyncStateHandlers = mapObjectValues(asyncStateInit, (key, value) => {
        return new AsyncStateHandler(value.initialValue);
    });
    return asyncStateHandlers;
}
const notSetSymbol = Symbol('not set');
export class AsyncStateHandler {
    constructor(initialValue) {
        _AsyncStateHandler_instances.add(this);
        _AsyncStateHandler_lastTrigger.set(this, notSetSymbol);
        _AsyncStateHandler_resolutionValue.set(this, void 0);
        _AsyncStateHandler_rejectionError.set(this, void 0);
        _AsyncStateHandler_listeners.set(this, []);
        _AsyncStateHandler_lastSetPromise.set(this, void 0);
        _AsyncStateHandler_waitingForValuePromise.set(this, createDeferredPromiseWrapper());
        this.asyncMarkerSymbol = asyncMarkerSymbol;
        if (initialValue) {
            this.setValue({ newPromise: initialValue });
        }
    }
    setValue(setInputs) {
        if ('createPromise' in setInputs) {
            if (__classPrivateFieldGet(this, _AsyncStateHandler_lastTrigger, "f") === notSetSymbol ||
                !areJsonEqual(setInputs.trigger, __classPrivateFieldGet(this, _AsyncStateHandler_lastTrigger, "f"))) {
                __classPrivateFieldSet(this, _AsyncStateHandler_lastTrigger, setInputs.trigger, "f");
                const newValue = setInputs.createPromise();
                __classPrivateFieldGet(this, _AsyncStateHandler_instances, "m", _AsyncStateHandler_setPromise).call(this, newValue);
            }
        }
        else if ('newPromise' in setInputs) {
            __classPrivateFieldGet(this, _AsyncStateHandler_lastTrigger, "f") === notSetSymbol;
            __classPrivateFieldGet(this, _AsyncStateHandler_instances, "m", _AsyncStateHandler_setPromise).call(this, setInputs.newPromise);
            // force a re-render
            __classPrivateFieldGet(this, _AsyncStateHandler_instances, "m", _AsyncStateHandler_fireListeners).call(this);
        }
        else if ('resolvedValue' in setInputs) {
            __classPrivateFieldGet(this, _AsyncStateHandler_instances, "m", _AsyncStateHandler_resolveValue).call(this, setInputs.resolvedValue);
        }
        else {
            if (setInputs.forceUpdate) {
                __classPrivateFieldSet(this, _AsyncStateHandler_lastTrigger, notSetSymbol, "f");
                __classPrivateFieldSet(this, _AsyncStateHandler_resolutionValue, undefined, "f");
                if (!__classPrivateFieldGet(this, _AsyncStateHandler_waitingForValuePromise, "f").isSettled()) {
                    __classPrivateFieldGet(this, _AsyncStateHandler_waitingForValuePromise, "f").reject('Canceled by force update');
                }
                __classPrivateFieldSet(this, _AsyncStateHandler_waitingForValuePromise, createDeferredPromiseWrapper(), "f");
                // force a re-render
                __classPrivateFieldGet(this, _AsyncStateHandler_instances, "m", _AsyncStateHandler_fireListeners).call(this);
            }
        }
    }
    getValue() {
        if (__classPrivateFieldGet(this, _AsyncStateHandler_waitingForValuePromise, "f").isSettled()) {
            if (__classPrivateFieldGet(this, _AsyncStateHandler_rejectionError, "f")) {
                return __classPrivateFieldGet(this, _AsyncStateHandler_rejectionError, "f");
            }
            else
                return __classPrivateFieldGet(this, _AsyncStateHandler_resolutionValue, "f");
        }
        else {
            return __classPrivateFieldGet(this, _AsyncStateHandler_waitingForValuePromise, "f").promise;
        }
    }
    addSettleListener(callback) {
        __classPrivateFieldGet(this, _AsyncStateHandler_listeners, "f").push(callback);
    }
    removeSettleListener(callback) {
        __classPrivateFieldSet(this, _AsyncStateHandler_listeners, __classPrivateFieldGet(this, _AsyncStateHandler_listeners, "f").filter((listener) => listener !== callback), "f");
    }
}
_AsyncStateHandler_lastTrigger = new WeakMap(), _AsyncStateHandler_resolutionValue = new WeakMap(), _AsyncStateHandler_rejectionError = new WeakMap(), _AsyncStateHandler_listeners = new WeakMap(), _AsyncStateHandler_lastSetPromise = new WeakMap(), _AsyncStateHandler_waitingForValuePromise = new WeakMap(), _AsyncStateHandler_instances = new WeakSet(), _AsyncStateHandler_fireListeners = function _AsyncStateHandler_fireListeners() {
    __classPrivateFieldGet(this, _AsyncStateHandler_listeners, "f").forEach((listener) => {
        listener();
    });
}, _AsyncStateHandler_setPromise = function _AsyncStateHandler_setPromise(newPromise) {
    if (newPromise === __classPrivateFieldGet(this, _AsyncStateHandler_lastSetPromise, "f")) {
        // abort setting the promise if we already have set this promise
        return;
    }
    __classPrivateFieldSet(this, _AsyncStateHandler_resolutionValue, undefined, "f");
    __classPrivateFieldSet(this, _AsyncStateHandler_rejectionError, undefined, "f");
    __classPrivateFieldSet(this, _AsyncStateHandler_lastSetPromise, newPromise, "f");
    if (__classPrivateFieldGet(this, _AsyncStateHandler_waitingForValuePromise, "f").isSettled()) {
        __classPrivateFieldSet(this, _AsyncStateHandler_waitingForValuePromise, createDeferredPromiseWrapper(), "f");
    }
    newPromise
        .then((value) => {
        // make sure we're still actually waiting for this promise
        if (__classPrivateFieldGet(this, _AsyncStateHandler_lastSetPromise, "f") === newPromise) {
            __classPrivateFieldGet(this, _AsyncStateHandler_instances, "m", _AsyncStateHandler_resolveValue).call(this, value);
        }
    })
        .catch((reason) => {
        // make sure we're still actually waiting for this promise
        if (__classPrivateFieldGet(this, _AsyncStateHandler_lastSetPromise, "f") === newPromise) {
            __classPrivateFieldSet(this, _AsyncStateHandler_rejectionError, ensureError(reason), "f");
            __classPrivateFieldGet(this, _AsyncStateHandler_waitingForValuePromise, "f").promise.catch(() => {
                /**
                 * Don't actually do anything, we just want to make sure the error is
                 * handled so it doesn't throw errors in the browser.
                 */
            });
            __classPrivateFieldGet(this, _AsyncStateHandler_waitingForValuePromise, "f").reject(reason);
            __classPrivateFieldGet(this, _AsyncStateHandler_instances, "m", _AsyncStateHandler_fireListeners).call(this);
        }
    });
}, _AsyncStateHandler_resolveValue = function _AsyncStateHandler_resolveValue(value) {
    if (value !== __classPrivateFieldGet(this, _AsyncStateHandler_resolutionValue, "f")) {
        __classPrivateFieldSet(this, _AsyncStateHandler_rejectionError, undefined, "f");
        __classPrivateFieldSet(this, _AsyncStateHandler_resolutionValue, value, "f");
        if (__classPrivateFieldGet(this, _AsyncStateHandler_waitingForValuePromise, "f").isSettled()) {
            __classPrivateFieldSet(this, _AsyncStateHandler_waitingForValuePromise, createDeferredPromiseWrapper(), "f");
        }
        __classPrivateFieldGet(this, _AsyncStateHandler_waitingForValuePromise, "f").resolve(value);
        __classPrivateFieldGet(this, _AsyncStateHandler_instances, "m", _AsyncStateHandler_fireListeners).call(this);
    }
};
export class AsyncStateInit {
    constructor(initialValue) {
        this.initialValue = initialValue;
        this.asyncMarkerSymbol = asyncMarkerSymbol;
    }
}
export function asyncState(initialValue) {
    return new AsyncStateInit(initialValue);
}
